import React from 'react';

import queryString from 'query-string';
import { FormattedMessage } from 'react-intl';
import { useNavigate, useLocation } from 'react-router-dom';

import { puckAndPlayerTrackingSelectors } from '../../../../../redux/ducks/puckAndPlayerTracking';

const MeasurementToggle = ({ conversionFactorKey }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const query = queryString.parse(location.search);

    return (
        <div className="measurement-toggle">
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    query.meas = puckAndPlayerTrackingSelectors.IMPERIAL_KEY;
                    navigate(`${location.pathname}?${queryString.stringify(query)}`);
                }}
                className={conversionFactorKey === puckAndPlayerTrackingSelectors.IMPERIAL_KEY ? 'disabled' : ''}
            >
                <FormattedMessage
                    defaultMessage="Imperial"
                    description="A word that denotes we are using the Imperial system of measurement. (Inches, Feet...)"
                />
            </a>{' '}
            |{' '}
            <a
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    query.meas = puckAndPlayerTrackingSelectors.METRIC_KEY;
                    navigate(`${location.pathname}?${queryString.stringify(query)}`);
                }}
                className={conversionFactorKey === puckAndPlayerTrackingSelectors.METRIC_KEY ? 'disabled' : ''}
            >
                <FormattedMessage
                    defaultMessage="Metric"
                    description="A word that denotes we are using the Metric system of measurement. (Centimeters, Meters...)"
                />
            </a>
        </div>
    );
};

export default MeasurementToggle;
